export function rgbaToRgb(imageData: Uint8Array | Uint16Array, width: number, height: number) {
	// const rgb = imageData instanceof Uint16Array ? new Uint16Array(size) : new Uint8Array(size)
	const rgb = imageData

	let pos, i, ii

	for (let row = 0; row < height; row++) {
		for (let col = 0; col < width; col++) {
			pos = col + row * width
			i = pos * 3
			ii = pos * 4
			rgb[i] = imageData[ii] as number
			rgb[i + 1] = imageData[ii + 1] as number
			rgb[i + 2] = imageData[ii + 2] as number
		}
	}

	return rgb
}

export function rgbaToRgbPlanar<T extends Uint8Array | Uint16Array>(
	rgbaData: T,
	width: number,
	height: number,
): T {
	const size = width * height

	// @ts-expect-error "Dynamic type"
	const planar: T = new rgbaData.constructor(size * 3)
	let index = 0

	for (let channel = 0; channel < 3; channel++) {
		for (let i = 0; i < size; i++) {
			planar[index++] = rgbaData[i * 4 + channel] ?? 0
		}
	}

	return planar
}
